import React from 'react';

type PropsType = React.SVGProps<SVGSVGElement>;

export function TestStartIcon(props: PropsType) {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        opacity="0.4"
        d="M4.30502 12C4.38752 11.6325 4.23752 11.1075 3.97502 10.845L2.15252 9.0225C1.58252 8.4525 1.35752 7.845 1.52252 7.32C1.69502 6.795 2.22752 6.435 3.02252 6.3L5.36252 5.91C5.70002 5.85 6.11252 5.55 6.27002 5.2425L7.56002 2.655C7.93502 1.9125 8.44502 1.5 9.00002 1.5C9.55502 1.5 10.065 1.9125 10.44 2.655L11.73 5.2425C11.8275 5.4375 12.03 5.625 12.2475 5.7525L4.17002 13.83C4.06502 13.935 3.88502 13.8375 3.91502 13.6875L4.30502 12Z"
        fill="#12B76A"
      />
      <path
        d="M14.1094 6.7627L14.1123 6.76367L14.8691 6.89062C15.4729 6.99316 15.7527 7.21779 15.8623 7.4209L15.8994 7.50684C15.9649 7.72776 15.9038 8.10892 15.415 8.59766L15.4141 8.59863L13.6006 10.4199C13.3769 10.6436 13.2282 10.9385 13.1475 11.2197C13.0677 11.4976 13.037 11.8245 13.1104 12.1328L13.1094 12.1338L13.627 14.3906L13.6279 14.3926C13.8315 15.2703 13.6335 15.637 13.4766 15.751C13.4049 15.8019 13.3073 15.8398 13.1543 15.8398C12.9151 15.8398 12.5716 15.7475 12.1328 15.4883H12.1338L9.93555 14.1836L9.93359 14.1816L9.82324 14.123C9.56159 13.9976 9.26737 13.9473 9 13.9473C8.69423 13.9473 8.35268 14.013 8.06543 14.1816L8.06348 14.1836L5.86914 15.4863C5.14904 15.908 4.74531 15.8737 4.56738 15.7783L13.3311 7.0166C13.5413 6.80631 13.8341 6.71464 14.1094 6.7627Z"
        fill="#12B76A"
        stroke="#12B76A"
        strokeWidth="1.2"
      />
    </svg>
  );
}
